import React, { createContext, useContext, useState } from "react";
const AuthContext = createContext(undefined);
export const AuthProvider = ({ children }) => {
    const [userId, setUserId] = useState(null);
    const [sessionId, setSessionId] = useState(null);
    const context = { userId, setUserId, sessionId, setSessionId };
    return React.createElement(AuthContext.Provider, { value: context }, children);
};
export const useAuthContext = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error("useAuthContext must be used within AuthProvider");
    }
    return context;
};
